/* eslint-disable react/jsx-one-expression-per-line, camelcase */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumberToFixed } from 'utils';
import { BlockHeading } from 'components/BlockHeading';
import { AppDataContext } from 'context/appData';
import { AuthContext } from 'context/auth';
import i18n from 'utils/i18n';

export const TotalInfo = ({
	quantity,
	m2,
	linearMeter,
	kg,
	materialCosts,
	shippingCosts,
	subtotal,
	vatCosts,
	total,
	allPricesAvailable,
	showPrice,
	priceVolumeCat,
}) => {
	const { configuratorData } = useContext(AppDataContext);
	const { currentUserAdditionalData } = useContext(AuthContext);
	const { construction_site_delivery_price_from, vat_percent } = configuratorData?.pricing || {};
	const { t } = useTranslation('configurationTableHeading');

	const loggedIn = !!currentUserAdditionalData;
	const showPrices = showPrice && allPricesAvailable;
	const showIfPriceEnabled = text => (showPrice ? text : ' ');
	const showFixedIfPriceEnabled = (p, ...r) => (showPrices ? formatNumberToFixed(p, ...r) : ' ');
	return (
		<div className="total_info">
			<BlockHeading title={t('totalCart')} iconName="equals" />
			<div className="total_info_table">
				<div className="total_info__cell light empty" />
				<div className="total_info__cell nobg end_pad_top" />
				<div className="total_info__cell end_pad_bottom" />
				<div className="total_info__cell light inset_pad" />
				<div className="total_info__cell total_txt light">{t('blocktotal')}</div>
				<div className="total_info__cell light qty_unit">{t('pc')}</div>
				<div className="total_info__cell light m2_unit">m²</div>
				<div className="total_info__cell light kg_unit">{t('kg')}</div>
				<div className="total_info__cell light lfm_unit">{t('linearMeterAbbrev')}</div>
				<div className="total_info__cell nobg mat_lbl">{showIfPriceEnabled(t('subtotal'))}</div>
				<div className="total_info__cell nobg ship_lbl">{showIfPriceEnabled(t('lsva'))}</div>
				<div className="total_info__cell subtotal_lbl bold">
					{showIfPriceEnabled(t('subtotal'))}
				</div>
				<div className="total_info__cell vat_lbl">
					{showIfPriceEnabled(
						`${t('vat')} (${formatNumberToFixed(vat_percent, 2, t('i18n:numberFormat'))}%)`
					)}
				</div>
				<div className="total_info__cell total_lbl bold">
					{showIfPriceEnabled(t('totalPriceChf'))}
				</div>

				<div className="total_info__cell light value qty">{quantity}</div>
				<div className="total_info__cell light value m2">
					{formatNumberToFixed(m2, 2, t('i18n:numberFormat'))}
				</div>
				<div className="total_info__cell light value kg">
					{formatNumberToFixed(kg, 0, t('i18n:numberFormat'))}
				</div>
				<div className="total_info__cell light value lfm">
					{formatNumberToFixed(linearMeter, 2, t('i18n:numberFormat'))}
				</div>

				<div className="total_info__cell sum nobg mat_costs">
					{showFixedIfPriceEnabled(materialCosts, 2, t('i18n:numberFormat'))}
				</div>
				<div className="total_info__cell sum nobg ship_costs">
					{showFixedIfPriceEnabled(shippingCosts, 2, t('i18n:numberFormat'))}
				</div>
				<div className="total_info__cell sum bold subtotal">
					{showFixedIfPriceEnabled(subtotal, 2, t('i18n:numberFormat'))}
				</div>
				<div className="total_info__cell sum vat_costs">
					{showFixedIfPriceEnabled(vatCosts, 2, t('i18n:numberFormat'))}
				</div>
				<div className="total_info__cell sum bold total">
					{showPrices
						? formatNumberToFixed(total, 2, t('i18n:numberFormat'))
						: allPricesAvailable
							? loggedIn
								? t('commonConfigurationAction:waitingForPriceApproval')
								: t('commonConfigurationAction:loginForPriceInfoBox')
							: t('commonConfigurationAction:priceOnDemand')}
				</div>
			</div>
			<div className="total_info__msg">
				<div className="total_info__volume_discount">
					{priceVolumeCat !== '0' &&
						showPrices &&
						t('volumeDiscountFmt').replace('{}', priceVolumeCat)}
					{m2 >= configuratorData?.pricing?.extra_text_from_volume?.volume_from && (
						<p className="total_info__extra_text_from_volume">
							{configuratorData.pricing.extra_text_from_volume[`text_${i18n.language}`]}
						</p>
					)}
				</div>
				<div className="total_info__delivery">
					{t('constructionSiteDeliveryFmt').replace('{}', construction_site_delivery_price_from)}
				</div>
			</div>
		</div>
	);
};

export default TotalInfo;
